import { useEffect } from 'react';

import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { required } from '../Forms/utils';

import { STYLED_TEXT } from '../Forms/fieldTypes';

// TODO: review form usage; it seems there is no need to a form
const SetPasswordComponent = (props) => {
  const { t } = useTransl();
  const { form, remoteSubmit, formError, initialValues, onSubmit } = props;

  useEffect(() => {
    const timeout = setTimeout(() => remoteSubmit(form), 100);
    return () => clearTimeout(timeout);
  }, []);

  const formData = [
    {
      keyName: 'token',
      label: t('title.token'),
      fieldType: STYLED_TEXT,
      validate: [required],
      disabled: true,
    },
    {
      keyName: 'uid',
      label: t('title.userId'),
      fieldType: STYLED_TEXT,
      validate: [required],
      disabled: true,
    },
    {
      keyName: 'id',
      label: t('title.id'),
      fieldType: STYLED_TEXT,
      validate: [required],
      disabled: true,
    },
  ];

  return (
    <Box
      display="flex"
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      {formError ? (
        <Typography variant="h5">{t('auth.confirmationFailed')}</Typography>
      ) : (
        <Typography variant="h5">{t('auth.confirming')}</Typography>
      )}
      <div style={{ display: 'none' }}>
        <GenericFormContainer
          form={form}
          formData={formData}
          onSubmit={onSubmit}
          initialValues={initialValues}
          canBeUpdated={false}
          title={t('auth.confirmContactInfo')}
          submitText={t('auth.confirmContactInfo')}
          isCentered
          disabled
        />
      </div>
    </Box>
  );
};

SetPasswordComponent.defaultProps = {
  formError: null,
};

SetPasswordComponent.propTypes = {
  form: PropTypes.string.isRequired,
  formError: PropTypes.instanceOf(Object),
  remoteSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
};

export default SetPasswordComponent;
